import "core-js/modules/es6.object.assign";
export var parser = function parser(tokens) {
  var current = 0;
  var currentLevel = 0;
  var nodeByLevel = [];
  var insidePipeInvocation = false;
  var insidePipeStatement = false;
  var insideSwitch = false;
  var insideUnion = false;
  var ast = {
    type: 'Program',
    children: []
  };

  while (current < tokens.length) {
    var child = walk();
    child && ast.children.push(child);
  }

  return ast;

  function walk() {
    var token = tokens[current];
    var negated = false;
    var defer = false;
    var wrap = false;

    if (!token || token.type === 'EmptyLine') {
      currentLevel = 0;
      current++;
      return null;
    }

    if (!token || token.type === 'NewLine') {
      current++;
      currentLevel = token.level;
      return null;
    }

    if (token.type === 'Union') {
      if (insideUnion) {
        current++;
        return null;
      }

      var unionNode = {
        type: 'UnionStatement',
        children: []
      };
      insideUnion = true;
      current++;
      var unionLevel = currentLevel;

      while ((token === null || token === void 0 ? void 0 : token.type) !== 'EmptyLine' && !((token === null || token === void 0 ? void 0 : token.type) === 'NewLine' && (token === null || token === void 0 ? void 0 : token.level) !== unionLevel)) {
        var node = walk();
        node && unionNode.children.push(node);
        token = tokens[current];
      }

      insideUnion = false;
      return unionNode;
    }

    if (token.type === 'SwitchCase' || token.type === 'DefaultSwitchCase') {
      var switchCase = {
        type: token.type,
        predicate: token["case"],
        value: token.value
      };
      current++;

      if (insideSwitch) {
        return switchCase;
      }

      var switchStatement = {
        type: 'SwitchStatement',
        cases: []
      };

      if (token.type === 'SwitchCase') {
        switchStatement.cases.push(switchCase);
      } else if (token.type === 'DefaultSwitchCase') {
        switchStatement["default"] = switchCase;
      }

      insideSwitch = true;

      while ((token === null || token === void 0 ? void 0 : token.type) === 'SwitchCase' || (token === null || token === void 0 ? void 0 : token.type) === 'DefaultSwitchCase' || (token === null || token === void 0 ? void 0 : token.type) === 'NewLine') {
        var _switchCase = walk();

        var type = _switchCase === null || _switchCase === void 0 ? void 0 : _switchCase.type;

        if (type === 'SwitchCase') {
          switchStatement.cases.push(_switchCase);
        } else if (type === 'DefaultSwitchCase') {
          switchStatement["default"] = _switchCase;
        }

        token = tokens[current];
      }

      insideSwitch = false;
      return switchStatement;
    }

    if (token.type === 'Negation') {
      negated = true;
      token = tokens[++current];
    }

    if (token.type === 'Wrap') {
      wrap = true;
      token = tokens[++current];
    }

    if (token.type === 'Defer') {
      defer = true;
      token = tokens[++current];
    }

    if (token.type === 'Arrow') {
      token = tokens[++current];

      if (token.type !== 'Function') {
        throw new SyntaxError('Invalid PipeStatement format');
      }

      var pipeStatement = {
        type: 'PipeStatement',
        value: token.value,
        children: []
      };
      insidePipeStatement = true;
      current++;

      while (token && token.type !== 'EmptyLine') {
        var _child = walk();

        _child && pipeStatement.children.push(_child);
        token = tokens[current];
      }

      insidePipeStatement = false;
      return pipeStatement;
    }

    if (token.type === 'Function') {
      var fnNode = Object.assign(Object.assign(Object.assign({
        type: 'Function',
        value: token.value,
        args: []
      }, negated && {
        negated: negated
      }), defer && {
        defer: defer
      }), wrap && {
        wrap: wrap
      });
      negated = false;
      defer = false;
      wrap = false;
      token = tokens[++current];

      while (token && token.type !== 'NewLine' && token.type !== 'EmptyLine') {
        var functionSubNode = walk();
        var disableAutoCurrying = fnNode.disableAutoCurrying,
            flipArguments = fnNode.flipArguments,
            _wrap = fnNode.wrap;
        var moreThanOneFlagActivated = disableAutoCurrying + flipArguments + _wrap > 1;

        if (moreThanOneFlagActivated) {
          throw new SyntaxError('Function with several special modifiers not supported');
        }

        if (functionSubNode.type === 'DisableAutoCurrying') {
          fnNode.disableAutoCurrying = true;
        } else if (functionSubNode.type === 'FlipArguments') {
          fnNode.flipArguments = true;
        } else {
          functionSubNode && fnNode.args.push(functionSubNode);
        }

        token = tokens[current];
      }

      if (!fnNode.args.length) {
        delete fnNode.args;
      }

      nodeByLevel[currentLevel] = fnNode;
      var baseLevel = insidePipeStatement || insideUnion ? 1 : 0;

      if (currentLevel > baseLevel) {
        var parentLevel = currentLevel - 1;

        if (!nodeByLevel[parentLevel]["if"]) {
          nodeByLevel[parentLevel]["if"] = fnNode;
        } else {
          nodeByLevel[parentLevel]["else"] = fnNode;
        }

        return null;
      }

      if (insidePipeInvocation || insidePipeStatement) {
        return fnNode;
      }

      var pipe = {
        type: 'PipeInvocation',
        children: [fnNode]
      };
      insidePipeInvocation = true;

      while (token && token.type !== 'EmptyLine') {
        var _child2 = walk();

        _child2 && pipe.children.push(_child2);
        token = tokens[current];
      }

      insidePipeInvocation = false;
      current++;
      return pipe;
    }

    if (token.type === 'String' || token.type === 'Number' || token.type === 'Variable') {
      current++;
      return {
        type: token.type,
        value: token.value
      };
    }

    if (token.type === 'Method') {
      var methodNode = {
        type: 'Method',
        value: token.value,
        args: []
      };
      token = tokens[++current];

      while (token && token.type !== 'NewLine' && token.type !== 'EmptyLine') {
        var args = walk();
        args && methodNode.args.push(args);
        token = tokens[current];
      }

      if (!methodNode.args.length) {
        delete methodNode.args;
      }

      return methodNode;
    }

    if (token.type === 'SideEffect') {
      current++;
      return Object.assign({
        type: 'SideEffect'
      }, token.value && {
        value: token.value
      });
    }

    if (token.type === 'Variadic') {
      current++;
      return {
        type: 'DisableAutoCurrying'
      };
    }

    if (token.type === 'Flip') {
      current++;
      return {
        type: 'FlipArguments'
      };
    }

    if (token.type === 'Defer') {
      current++;
      return {
        type: 'Defer'
      };
    }

    throw new SyntaxError(token.type + ' token type not supported');
  }
};